export var version = {
  'lib': '1.1550.5',
  'product': '1.1550.5',
  'supportedApiVersion': 2
};



/** WEBPACK FOOTER **
 ** ./src/misc/Version.ts
 **/